import { HTMLAttributes, useMemo } from 'react'

import { sectionsMap } from '@/components/sections'

import { WPPageData } from '@/types'

export type BuilderProps = HTMLAttributes<HTMLElement> & {
  pageProps?: WPPageData
}

const Builder = ({ pageProps }: BuilderProps) => {
  const builder = useMemo(() => pageProps?.acf?.builder || [], [pageProps])

  return (
    <>
      {builder.map(({ acf_fc_layout, ...section }: any, index: number) => {
        const Section = sectionsMap[acf_fc_layout]

        return Section ? (
          <Section key={`section-${index}`} {...section} {...{ [`data-${acf_fc_layout}`]: true }} />
        ) : null
      })}
    </>
  )
}

export default Builder
